import { apiService } from "./apiService"
import { endpoints } from "./endpoints"

export const econtService = {
    getOffices: () => apiService.post(endpoints.econt.getOffices, {}),
    validateLabel: (data: any) => apiService.post(endpoints.econt.validateLabel, data),
    createLabel: (data: any) => apiService.post(endpoints.econt.createLabel, data),
    getOfficesByCity: (cityId: number) => apiService.post(endpoints.econt.getOfficesByCityId(cityId), {})
}
